var _defs, _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContacts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "contacts_svg__Group_15987",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "contacts_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contacts_svg__Rectangle_9",
    d: "M0 0h24v25H0z",
    className: "contacts_svg__cls-1"
  })), /*#__PURE__*/React.createElement("style", null, ".contacts_svg__cls-1{fill:inherit}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "contacts_svg__Rectangle_202",
    fill: "none",
    d: "M0 0h48v48H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contacts_svg__Mask_Group_3",
    clipPath: "url(#contacts_svg__clip-path)",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contacts_svg__user_9_",
    transform: "translate(0 .344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contacts_svg__Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contacts_svg__Path_26",
    d: "M20.485 15.938A11.913 11.913 0 0015.925 13a7.18 7.18 0 003.012-5.873A7.042 7.042 0 0012 0a7.042 7.042 0 00-6.937 7.127A7.18 7.18 0 008.075 13a11.913 11.913 0 00-4.56 2.938A12.419 12.419 0 000 24.656h1.875A10.278 10.278 0 0112 14.254a10.278 10.278 0 0110.125 10.4H24a12.419 12.419 0 00-3.515-8.716zM12 12.328a5.139 5.139 0 01-5.062-5.2A5.139 5.139 0 0112 1.926a5.139 5.139 0 015.063 5.2A5.139 5.139 0 0112 12.328z",
    className: "contacts_svg__cls-1"
  }))))));
}

export default SvgContacts;